import { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'
import { getCookieSettings } from '@lib/cookies'
import TagManager from 'react-gtm-module'

const Tracking: FC = () => {
  const { asPath } = useRouter()
  const cookieSettings = getCookieSettings()
  const { NEXT_PUBLIC_STAGE } = process.env

  useEffect(() => {
    // Init GA tracking in production
    ReactGA.initialize(process.env.NEXT_PUBLIC_GA_TRACKING_ID)
    ReactGA.plugin.require('ecommerce')

    if (!cookieSettings || !cookieSettings.includes('analytical')) {
      ReactGA.set({ anonymizeIp: true })
    }

    // Facebook pixel
    if (
      cookieSettings.includes('personal') &&
      ['staging', 'production'].includes(NEXT_PUBLIC_STAGE)
    ) {
      ReactPixel.init('1766956210287884', undefined, { debug: true, autoConfig: true })
    }

    // Tag manager
    if (
      cookieSettings.includes('analytical') &&
      cookieSettings.includes('personal') &&
      ['staging', 'production'].includes(NEXT_PUBLIC_STAGE)
    ) {
      TagManager.initialize({ gtmId: 'GTM-WRDV5CC' })
    }
  }, []) //eslint-disable-line

  useEffect(() => {
    ReactGA.pageview(asPath)

    if (
      ['staging', 'production'].includes(NEXT_PUBLIC_STAGE) &&
      cookieSettings.includes('personal')
    ) {
      ReactPixel.pageView()
    }
  }, [asPath]) //eslint-disable-line

  return null
}

export default Tracking
